'use strict';

/* ===================================================================================== @preserve =
 ___  _   _    _
/   || | | |  | |
\__  | | | |  | |  __
/    |/  |/_) |/  /  \_/\/
\___/|__/| \_/|__/\__/  /\_/
               |\
               |/
Ajaxinate - Optimized Version
based on v2.0.11
https://github.com/Elkfox/Ajaxinate
Copyright (c) 2017 Elkfox Co Pty Ltd
https://elkfox.com
MIT License
================================================================================================= */

var Ajaxinate = function ajaxinateConstructor(config) {
  var settings = config || {};
  /*
    pagination: Selector of pagination container
    method: [options are 'scroll', 'click']
    container: Selector of repeating content
    offset: 0, offset the number of pixels before the bottom to start loading more on scroll
    loadingText: 'Loading', The text changed during loading
    callback: null, function to callback after a new page is loaded
    preload: false, whether to preload the next page in advance
  */
  var defaultSettings = {
    pagination: '#AjaxinatePagination',
    method: 'scroll',
    container: '#AjaxinateLoop',
    offset: 0,
    loadingText: 'Loading...',
    callback: null,
    preload: true // New option to preload the next page
  };
  // Merge configs
  this.settings = Object.assign(defaultSettings, settings);

  // Bind 'this' to applicable prototype functions
  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.destroy = this.destroy.bind(this);
  this.preloadNextPage = this.preloadNextPage.bind(this);

  // Set up our element selectors
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);
  
  // Store preloaded content
  this.preloadedContent = null;
  this.isPreloading = false;

  this.initialize();
};

Ajaxinate.prototype.initialize = function initializeTheCorrectFunctionsBasedOnTheMethod() {
  // Find and initialise the correct function based on the method set in the config
  if (this.containerElement) {
    var initializers = {
      click: this.addClickListener,
      scroll: this.addScrollListeners
    };
    initializers[this.settings.method]();
    
    // Start preloading if enabled
    if (this.settings.preload && this.paginationElement) {
      this.preloadNextPage();
    }
  }
};

Ajaxinate.prototype.addScrollListeners = function addEventListenersForScrolling() {
  if (this.paginationElement) {
    document.addEventListener('scroll', this.checkIfPaginationInView);
    window.addEventListener('resize', this.checkIfPaginationInView);
    window.addEventListener('orientationchange', this.checkIfPaginationInView);
  }
};

Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.clickActive = true;
    if (this.nextPageLinkElement !== null) {
      this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
    }
  }
};

Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
  event.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    
    // If we have preloaded content, use it immediately
    if (this.preloadedContent && this.nextPageUrl === this.preloadedUrl) {
      this.renderPreloadedContent();
    } else {
      // Otherwise load normally
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
  var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
  var bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.removeScrollListener();
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerHTML = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      
      // If we have preloaded content, use it immediately
      if (this.preloadedContent && this.nextPageUrl === this.preloadedUrl) {
        this.renderPreloadedContent();
      } else {
        // Otherwise load normally
        this.loadMore();
      }
    }
  }
};

// New method to preload the next page
Ajaxinate.prototype.preloadNextPage = function preloadTheNextPageInAdvance() {
  if (this.isPreloading || !this.paginationElement) return;
  
  this.nextPageLinkElement = this.paginationElement.querySelector('a');
  if (!this.nextPageLinkElement) {
    console.log('No more pages to load - pagination link not found');
    return;
  }
  
  this.preloadedUrl = this.nextPageLinkElement.href;
  this.isPreloading = true;
  
  console.log('Preloading next page:', this.preloadedUrl);
  
  var preloadRequest = new XMLHttpRequest();
  preloadRequest.onreadystatechange = function() {
    if (preloadRequest.readyState === 4 && preloadRequest.status === 200) {
      this.preloadedContent = preloadRequest.responseXML;
      this.isPreloading = false;
      
      // Check if there are products in the next page
      var nextPageContainer = this.preloadedContent.querySelectorAll(this.settings.container)[0];
      var productCount = nextPageContainer ? nextPageContainer.children.length : 0;
      console.log('Preloaded page contains', productCount, 'products');
      
      // Check if there's a next page after this one
      var nextPagination = this.preloadedContent.querySelectorAll(this.settings.pagination)[0];
      var hasMorePages = nextPagination && nextPagination.querySelector('a');
      console.log('Has more pages after this one:', hasMorePages ? 'Yes' : 'No');
    }
  }.bind(this);
  
  preloadRequest.open('GET', this.preloadedUrl);
  preloadRequest.responseType = 'document';
  preloadRequest.send();
};

// New method to render preloaded content
Ajaxinate.prototype.renderPreloadedContent = function renderThePreloadedContent() {
  if (!this.preloadedContent) return;
  
  var newContainer = this.preloadedContent.querySelectorAll(this.settings.container)[0];
  var newPagination = this.preloadedContent.querySelectorAll(this.settings.pagination)[0];
  
  // Check if there's a next page link in the new pagination element
  var hasNextPage = newPagination && newPagination.querySelector('a');
  console.log('Rendering preloaded content. Has next page:', hasNextPage ? 'Yes' : 'No');
  
  // Use requestAnimationFrame for smoother rendering
  requestAnimationFrame(function() {
    // Only insert content if there's something to insert
    if (newContainer && newContainer.innerHTML.trim()) {
      this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
    }
    
    // Update pagination only if it exists
    if (newPagination) {
      this.paginationElement.innerHTML = newPagination.innerHTML;
    } else {
      // If no pagination in response, clear the pagination element
      this.paginationElement.innerHTML = '';
    }
    
    // Run callback if provided
    if (this.settings.callback && typeof this.settings.callback === 'function') {
      this.settings.callback(this.preloadedContent);
    }
    
    // Initialize for next page only if there's a next page link
    if (hasNextPage) {
      this.initialize();
      
      // Clear preloaded content
      this.preloadedContent = null;
      
      // Start preloading the next page immediately
      if (this.settings.preload) {
        setTimeout(this.preloadNextPage, 100);
      }
    } else {
      console.log('No more pages to load - reached end of collection');
      this.preloadedContent = null;
    }
  }.bind(this));
};

Ajaxinate.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
  this.request = new XMLHttpRequest();
  this.request.onreadystatechange = function success() {
    if (this.request.readyState === 4 && this.request.status === 200) {
      var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
      var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
      
      // Count products in the loaded page
      var productCount = newContainer ? newContainer.children.length : 0;
      console.log('Loaded page contains', productCount, 'products');
      
      // Check if there's a next page link in the new pagination element
      var hasNextPage = newPagination && newPagination.querySelector('a');
      console.log('Loading content. Has next page:', hasNextPage ? 'Yes' : 'No');
      
      // Use requestAnimationFrame for smoother rendering
      requestAnimationFrame(function() {
        // Only insert content if there's something to insert
        if (newContainer && newContainer.innerHTML.trim()) {
          this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
        }
        
        // Update pagination only if it exists
        if (newPagination) {
          this.paginationElement.innerHTML = newPagination.innerHTML;
        } else {
          // If no pagination in response, clear the pagination element
          this.paginationElement.innerHTML = '';
        }
        
        // Run callback if provided
        if (this.settings.callback && typeof this.settings.callback === 'function') {
          this.settings.callback(this.request.responseXML);
        }
        
        // Initialize for next page only if there's a next page link
        if (hasNextPage) {
          this.initialize();
          
          // Start preloading the next page immediately
          if (this.settings.preload) {
            setTimeout(this.preloadNextPage, 100);
          }
        } else {
          console.log('No more pages to load - reached end of collection');
        }
      }.bind(this));
    }
  }.bind(this);
  
  this.request.open('GET', this.nextPageUrl);
  this.request.responseType = 'document';
  this.request.send();
};

Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
  this.nextPageLinkElement.removeEventListener('click', this.stopMultipleClicks);
};

Ajaxinate.prototype.removeScrollListener = function removeScrollEventListener() {
  document.removeEventListener('scroll', this.checkIfPaginationInView);
  window.removeEventListener('resize', this.checkIfPaginationInView);
  window.removeEventListener('orientationchange', this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function removeEventListenersAndReturnThis() {
  // This method is used to unbind event listeners from the DOM
  // This function is called manually to destroy "this" Ajaxinate instance
  var destroyers = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener
  };
  destroyers[this.settings.method]();
  return this;
};
